import { LexContentType } from "@/types/common";
import React from "react";
import { serializeToReact } from "./serializeToReact";
import { formatDistanceToNow } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

export default function LiveUpdateComponent({
  updates,
}: {
  updates: { id: number; date: Date; content: LexContentType }[];
}) {
  return (
    <div>
      <div className="flex items-center gap-2 px-2 py-1 bg-red-500 rounded w-max ">
        <span className="block w-2 h-2 bg-white rounded-full animate-pulse"></span>
        <span className="text-xs font-medium text-white uppercase">Live Updates</span>
      </div>

      <div className="mt-4">
        {updates?.map((update, index) => {
          const content = update?.content ? serializeToReact(update?.content) : <></>;
          return (
            <div
              key={index}
              className="relative bg-[#fbfbfb] dark:bg-darkBgSecondaryColor p-4 mb-4 last:mb-0 border border-[#E9E9E9] dark:border-black rounded-md"
            >
            <span className="block text-[13px] font-medium text-red-500 uppercase mb-1">
                {formatDistanceToNow(update.date, { addSuffix: true })}
              </span>
              <span className="block mb-2 text-xs uppercase">
                {formatInTimeZone(update?.date, "Asia/Kolkata", "MMM dd, yyyy hh:mm a")} IST
              </span>

              <span className="absolute block w-2 h-2 bg-red-500 rounded-full left-[-4px] top-[21px]"></span>

              {content}
            </div>
          );
        })}
      </div>
    </div>
  );
}
